import { defineComponent as _defineComponent } from 'vue'
import { Message } from 'element-ui'
import { nextTick, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-assistant-composer',
  props: {
    busy: { type: Boolean }
  },
  emits: ["send"],
  setup(__props: any, { expose, emit: emits }: { emit: ({ (event: 'send', text: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { busy: boolean }




const QUICK_SKILLS = [
  {
    id: 'order-import',
    name: '导入柜柜订单',
    hint: '把柜柜订单导入当前云排版',
    placeholder: '例如：订单号为 GD20261010018、GD20261008007',
    prompt: '查询可导入的柜柜订单',
    icon: 'el-icon-document',
  },
  {
    id: 'production-history',
    name: '查询生产记录',
    hint: '按订单或时间范围查找生产文件',
    placeholder: '例如：最近七天，或订单号 GD20260928001',
    prompt: '查询生产文件记录',
    icon: 'el-icon-tickets',
  },
] as const
const draft = ref('')
const selectedQuickSkill = ref<(typeof QUICK_SKILLS)[number] | null>(null)
const quickSkillMenuOpen = ref(false)
const composerInputRef = ref<HTMLTextAreaElement | null>(null)

function reset() {
  draft.value = ''
  selectedQuickSkill.value = null
  quickSkillMenuOpen.value = false
}

function submit() {
  const text = draft.value.trim()
  if (!text || props.busy) return
  emits('send', text)
  reset()
}

function selectQuickSkill(skill: (typeof QUICK_SKILLS)[number]) {
  selectedQuickSkill.value = skill
  draft.value = skill.prompt
  quickSkillMenuOpen.value = false
  nextTick(() => composerInputRef.value?.focus())
}

function clearQuickSkill() {
  selectedQuickSkill.value = null
  quickSkillMenuOpen.value = false
  nextTick(() => composerInputRef.value?.focus())
}

function showHingeHoleUnavailable() {
  Message.info('添加铰链孔功能暂未开放')
}

expose({ reset })

return { __sfc: true,props, emits, QUICK_SKILLS, draft, selectedQuickSkill, quickSkillMenuOpen, composerInputRef, reset, submit, selectQuickSkill, clearQuickSkill, showHingeHoleUnavailable }
}

})